import React from 'react';
import styled from 'styled-components';
import { PHONE_WIDTH } from '~~elements/Const';
import UTRMultilingual from '../../Multilingual';

const StyledDiv = styled.div`
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  label {
    margin: 0 1rem;
  }

  .basic-info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    > * {
      border-bottom: 1px solid #eee;
      margin: 0;
      padding: 0.25rem 0.5rem;
      &.row-gap {
        margin-bottom: 1rem;
      }
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    font-size: 0.9rem;
    .basic-info {
      grid-template-columns: 1fr;
      > *:nth-child(odd) {
        border-bottom: 0px;
      }
    }
  }
`;

const OverviewSection = ({ teamInRegistry, registry }) => {
  return (
    <StyledDiv>
      <div className="basic-info">
        <h4>{UTRMultilingual(`CUSTOM.TABLE.TOURNAMENT`)}</h4>
        <label>{teamInRegistry.season.title}</label>
        <h4>{UTRMultilingual(`CUSTOM.TABLE.TEAM`)}</h4>
        <label>{teamInRegistry.name}</label>
        <h4>{UTRMultilingual(`TEAM.CITY`)}</h4>
        <label>{teamInRegistry.city}</label>
        <h4>{UTRMultilingual(`CUSTOM.TABLE.HISTORY_CONNECTION`)}</h4>
        <label>
          {!teamInRegistry.connected_team ? UTRMultilingual(`COMMON.NONE`) : teamInRegistry.connected_team.name}
        </label>
        <h4>{UTRMultilingual(`CUSTOM.TABLE.STATUS`)}</h4>
        <label>{UTRMultilingual(`CUSTOM.STATUS.${teamInRegistry.status}`)}</label>
        <label />
        <label />
        <h4>{UTRMultilingual(`CUSTOM.REGISTRY_INFO`)}</h4>
        <label>
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/registry/${registry.uniqid}`}
            target="_blank"
            rel="noopener noreferrer"
          >{`${process.env.REACT_APP_MAINPAGE_URL}/registry/${registry.uniqid}`}</a>
        </label>
      </div>
    </StyledDiv>
  );
};

export default OverviewSection;
